export class AdminClientesFactory {
  constructor(instance) {
    this.instance = instance;
  }

  listar(params) {
    return this.instance.get('/adm/contas', { params });
  }

  exibir(id, params) {
    return this.instance.get(`/adm/contas/${id}`, { params });
  }

  criar(data) {
    return this.instance.post('/adm/contas', data);
  }

  atualizar(id, data) {
    return this.instance.put(`/adm/contas/${id}/cliente`, data);
  }
}
